import React from 'react';

import { useTranslation } from 'react-i18next';

import ChevronTopIcon from '../../../../assets/icons/ChevronTopIcon';
import { colorsPalette } from '../../../../theme';
import { useBtnStyles } from './style';

const ShowMoreBtn = ({ listIsOpen, handleClick }) => {
  const { t } = useTranslation();
  const classes = useBtnStyles(listIsOpen)();

  return (
    <button onClick={handleClick} className={classes.btn}>
      <span className={classes.text}>
        {listIsOpen ? t('button.showLess') : t('button.showMore')}
      </span>
      <ChevronTopIcon color={colorsPalette.white} className={classes.icon} />
    </button>
  );
};

export default ShowMoreBtn;
